const OutcomeLabelHalfTimeFullTime = {
    title: 'Example JSON',
    expectedOutput: 'EventHomeName/Draw',
    initialDisplayedCode: `{
      "outcomeId": 2950948551,
      "betOffer": {
        "id": 883929922,
        "betOfferType": {
          "id": 8,`,
    moreCode: `
    "name": "betOffer name"
  },
  "place": false,
      "outcomes": [
        {
          "id": 2950948551,
          "label": "Arsenal",
          "type": "OT_ONE_CROSS"
        },
        {
          "id": 2950948554,
          "label": "Feyenoord",
          "type": "OT_ONE_ONE"
        }
      ]
    },
    "event": {
      "awayName": "EventAwayName",
      "homeName": "EventHomeName"
    }
  }`,
};

export default OutcomeLabelHalfTimeFullTime;
